<template>
  <div class="mobile-dates">
    <div class="month">NOV</div>
    <div class="days">
      <div class="day">
        <div class="name">Sun</div>
        <div class="date">1</div>
      </div>
      <div class="day">
        <div class="name">Mon</div>
        <div class="date">2</div>
      </div>
      <div class="day">
        <div class="name">Tue</div>
        <div class="date">3</div>
      </div>
      <div class="day">
        <div class="name">Wed</div>
        <div class="date">4</div>
      </div>
      <div class="day">
        <div class="name">Thru</div>
        <div class="date">5</div>
      </div>
      <div class="day">
        <div class="name">Fri</div>
        <div class="date">6</div>
      </div>
      <div class="day">
        <div class="name">Sat</div>
        <div class="date">7</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.mobile-dates {
  display: flex;
  background: #456;
  width: 400px;
}

.month {
  font-size: 24px;
  flex: 0 0 60px;
}

.days {
  flex: 1 1 auto;
  display: flex;
  overflow-x: scroll;
}

.day {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ddd;
  margin: 6px;
  height: 60px;
  width: 60px;
  box-sizing: border-box;
}

.name {
  font-weight: 700;
  font-size: 14px;
}

</style>
